<template>
    <transition name="sale">
        <div class="sale" v-if="discount">
            <h1 class="sale-title" v-html="discountText">
                <span class="discount">Скидка -{{discount}}% </span>
            </h1>
            <p>акция закончится через</p>
            <div class="time-limit">
                <div class="time">
                    <h1>{{getDays}}</h1>
                    <p>{{getDaysDeclension}}</p>
                </div>
              <span class="colon">:</span>
                <div class="time">
                    <h1>{{getHours}}</h1>
                    <p>{{getHoursDeclension}}</p>
                </div>
                <span class="colon">:</span>
                <div class="time">
                    <h1>{{getMinutes}}</h1>
                    <p>{{getMinutesDeclension}}</p>
                </div>
                <span class="colon">:</span>
                <div class="time">
                    <h1>{{getSeconds}}</h1>
                    <p>{{getSecondsDeclension}}</p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import * as moment from "moment";
    import {mapActions, mapState} from "vuex";
    import {declension} from "@/utils/word";

    export default {
        name: "sale",
        data: () => ({
            now: Date.now(),
            interval: false,
        }),
        mounted() {
            // if(this.discount)
            this.getDiscount().then(() => {
                this.limitCheck();

                this.interval = setInterval(() => {
                    this.now = Date.now();
                    this.limitCheck();
                }, 1000)
            });
        },
        beforeDestroy() {
            clearInterval(this.interval)
        },
        computed: {
            discountText() {
                if (this.discount) return this.discount.text;
                else return "&nbsp;";
            },
            timeLimit() {
                if (this.discount) return this.discount.end * 1000;
                else return 0;
            },
            getDays() {
                return this.getTime('days', 24);
            },
            getDaysDeclension() {
                return declension(this.getDays, 'день', 'дня', 'дней');
            },
            getHours() {
                return this.getTime('hours', 24);
            },
            getHoursDeclension() {
                return declension(this.getHours, 'час', 'часа', 'часов');
            },
            getMinutes() {
                return this.getTime('minutes', 60);
            },
            getMinutesDeclension() {
                return declension(this.getMinutes, 'минута', 'минуты', 'минут');
            },
            getSeconds() {
                return this.getTime('seconds', 60);
            },
            getSecondsDeclension() {
                return declension(this.getSeconds, 'секунда', 'секунды', 'секунд');
            },
            ...mapState('main', ['discount'])
        },
        methods: {
            getTime(measuring, remainder = 0) {
                return this.addition(moment(this.timeLimit).diff((this.now), measuring) % remainder);
            },
            addition(time) {
                if (time < 0) return '00';
                if (time >= 10) return time;
                else return '0' + time;
            },
            limitCheck() {
                if (this.timeLimit - this.now < 0) {
                    clearInterval(this.interval);
                }
            },
            ...mapActions('main', ['getDiscount'])
        }
    }
</script>

<style scoped lang="scss">

    .sale-enter-active, .sale-leave-active {
        transition: 400ms ease-out;
        transition-property: max-height, padding;
    }

    .sale-enter, .sale-leave-to {
        max-height: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .sale {
        max-height: 200px;
        overflow: hidden;

        padding: 24px;
        text-align: center;
        margin-bottom: 16px;
        border-radius: 4px;
        border: 1px solid $bg_light_plus;

        & > * {
            transition: none;
        }

        h1.sale-title {
            margin-bottom: 12px;

            &::v-deep p {
                display: inline-block;
                color: $blue;
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;
            }
        }

        .time-limit {
            $height: 48px;
            @include tablet {
                $height: 44px;
            }
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .time {
                width: 100%;

                h1 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 4px;
                    height: $height;

                    border-radius: 4px;
                    text-shadow: 0 12px 24px rgba($blue, 0.64);
                    color: $blue !important;
                    background-color: rgba($blue, 0.12);
                }

            }

            .colon {
                flex-shrink: 0;
                width: 32px;
                line-height: $height;

                font-weight: bold;
                font-size: 16px;
                color: rgba($blue, 0.24);
            }
        }

        @include tablet {
            padding: 16px;
            margin-bottom: 12px;

            h1.sale-title {
                text-align: start;
                font-size: 20px !important;
                line-height: 25px !important;
                margin-bottom: 8px;
            }
            > p {
                text-align: start;
            }
            .time-limit {
                justify-content: flex-start;

                .time {
                    max-width: 64px;

                    p {
                        font-size: 12px;
                        font-weight: 500;
                    }

                }

                .colon {
                    width: 24px;
                }
            }
        }
    }
</style>
